export default "__VITE_ASSET__DtIMyZ5a__"